import React, { useMemo } from 'react';
import { Card, Typography, Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { marked } from 'marked';

const SummaryTab = ({ summaries }) => {
    const { t } = useTranslation();

    const memoizedSummaries = useMemo(() => summaries, [summaries]);

    const formatTime = (seconds) => {
        const unixSeconds = Math.floor(new Date(seconds).getTime() / 1000);
        const hours = Math.floor(unixSeconds / 3600);
        const minutes = Math.floor((unixSeconds % 3600) / 60);
        const secs = Math.floor(unixSeconds % 60);

        let result = '';
        if (hours > 0) result += `${hours}h `;
        if (minutes > 0 || hours > 0) result += `${minutes}m `;
        result += `${secs}s`;

        return result.trim();
    };

    const renderSummaryItem = (item) => (
        <Card
            key={item.id}
            style={{
                marginBottom: '16px',
                borderRadius: '8px',
                backgroundColor: '#f8f8f8'
            }}
        >
            <div style={{ marginBottom: '8px' }}>
                <Typography.Text type="secondary">
                    {formatTime(item.start_time)} ~ {formatTime(item.end_time)}
                </Typography.Text>
            </div>
            <Typography.Text>
                <div dangerouslySetInnerHTML={{ __html: marked(item.summary_text) }} />
            </Typography.Text>
        </Card>
    );

    return (
        <div style={{
            height: '100%',
            overflow: 'auto',
            padding: '0 16px'
        }}>
            {memoizedSummaries.length > 0 ? (
                memoizedSummaries.map(renderSummaryItem)
            ) : (
                <Empty description={t("No summaries available")} />
            )}
        </div>
    );
};

export default SummaryTab;